$( document ).ready(function() {
    function experience_carousel(){
        const swiper = new Swiper('.c-experiences__main-old', {
            // Optional parameters
            slidesPerView: '4',
            spaceBetween: 32,
            grabCursor: true,
            //Breakpoint
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: '1',
                    spaceBetween: 10,
                },
                // when window width is >= 480px
                899: {
                    slidesPerView: '3',
                    spaceBetween: 32,
                },
                // when window width is >= 480px
                1024: {
                    slidesPerView: '4',
                    spaceBetween: 32,
                },
                1400: {
                    slidesPerView: '5',
                    spaceBetween: 32,
                }
            },
            // Pagination progressbar
            pagination: {
                el: '.c-experiences__progress',
                type: 'progressbar',
            },
            // Navigation arrows
            navigation: {
                nextEl: '.c-experiences__button-next',
                prevEl: '.c-experiences__button-prev',
            }
        });
    }
    experience_carousel();
});
